import {
    BANKACCOUNT_GETALL_SUCCESS,
    BANKACCOUNT_GETALL_FAIL,
    BANKACCOUNT_UPSERT_SUCCESS,
    BANKACCOUNT_UPSERT_FAIL,
    BANKACCOUNT_DELETE_SUCCESS,
    BANKACCOUNT_DELETE_FAIL,
    SET_MESSAGE
  } from "./types";
  
  import BankAccountService from "../services/bankaccount-service";
  
  export const getBankAccounts = () => (dispatch) => {
    return BankAccountService.getBankAccounts().then(
      (data) => {
        dispatch({
          type: BANKACCOUNT_GETALL_SUCCESS,
          payload: { bankaccounts : data },
        });
        return Promise.resolve();
      },
      (error) => {
        dispatch({ type: BANKACCOUNT_GETALL_FAIL });
        dispatch({
          type: SET_MESSAGE,
          payload: `Bank Account retrieval failed : ${error}`,
        });
        return Promise.reject();
      }
    );
  };
  
  export const upsertBankAccount = (bankaccount) => (dispatch) => {
    return BankAccountService.upsertBankAccount(bankaccount).then(
      (data) => {
        dispatch({ type: BANKACCOUNT_UPSERT_SUCCESS, payload: data });
        return Promise.resolve();
      },
      (error) => {
        dispatch({ type: BANKACCOUNT_UPSERT_FAIL });
        dispatch({
          type: SET_MESSAGE,
          payload: `Bank Account upsert failed - ${error}`,
        });
        return Promise.reject();
      }
    );
  };
  
  export const deleteBankAccount = (bankaccount_id) => (dispatch) => {
    return BankAccountService.deleteBankAccount(bankaccount_id).then(
      () => {
          dispatch({ type: BANKACCOUNT_DELETE_SUCCESS, payload : bankaccount_id });
          return Promise.resolve();

      },
      (error) => {
          dispatch({ type: BANKACCOUNT_DELETE_FAIL });
          dispatch({ type: SET_MESSAGE, payload: `Bank Account delete failed - ${error}` });
          return Promise.reject();
      }
    );
  };